import acknowledgeTemplateEn from '@/i18n/acknowledgeRisk/en'
import termsAndConditionsTemplateEn from '@/i18n/termsAndConditions/en'

export const en = {
  messages: {
    per_total_income: 'per total income',
    please_specify: 'Please specify',
    loading: 'Loading',
    close: 'Close',
    back: 'Back',
    receive: 'Receive',
    for_receive: 'For receive',
    copied: 'Copied !',
    can_not_copy: `Can't copy, please try again`,
    no_result_found: 'No results found',
    img_size_must_less_than: 'Image size must less than {0} MB',
    uploading_your: 'Uploading your',
    submitting_your_info: 'Submitting your information',
    click_to_see_doc: 'Click to see document',
    congratulations: 'Congratulations',
    you_have_got_kul: `You've got {0} KUL`,
    thanks_for_connect_social_with_us: 'Thank you for connected {0} with us',
    thanks_for_subscribe:
      'Thank you for connected subscribe to newsletters with us',
    thanks_for_registration: 'Thank you for your registration',
    thanks_for_submited: 'Thank you for the identification documents.',
    submit: 'Submit',
    system_error: 'System error',
    submit_suitability_test_success: 'Submit suitability test success',
    submit_knowledge_test_success: 'Submit knowledge test success',
    submit_kyc_success: 'Submit KYC success',
    please_upload_image: 'Please upload image',
    google: 'Google',
    facebook: 'Facebook',
    not_support: 'Not support',
    wrong_eth_network:
      '<span>Please switch your wallet network to <b>{0} Ethereum Network</b>.</span>',
    please_fill_info: 'Please fill information',
    hi: 'Hi',
    please_confirm_email_after_regis:
      'Please confirm your email after completed registration',
    resend_an_email: 'Resend an email',
    metamask_connected: 'Metamask Connected !',
    wallet_connect_connected: 'WalletConnect Connected !',
    login_error: 'Login Error',
    not_login_metamask:
      'You are not logged in on <b>MetaMask</b>, Please login and try again.'
  },
  button: {
    login: 'Login'
  },
  validation: {
    invalid_email: 'Invalid email',
    required: 'Required',
    password_complexity:
      'Password has to be between 8-30 characters, and contain at least one uppercase letter, one lowercase letter, and a number',
    terms_required:
      'You must agree with the Terms of Use, Privacy Policy and AML/KYC',
    invalid_token_address: 'Invalid {{token}} address',
    objective_required: 'Objective of trading field is required',
    other_objective_required:
      'The other objective of trading field is required',
    answer_required: 'Answer is required',
    at_least_one_answer: 'At least one answer is required',
    at_least_one_country: 'At least {{count}} country is required',
    only_country_count: 'Only {{count}} countries are allowed',
    max_country_count: 'A maximum of {{count}} countries are allowed',
    high_volume_objective_notice:
      'Your trading volume is over 100,000 Baht. Please fill in the objective of trading.',
    cancel_objective_notice:
      'If you ignore or cancel this form, we will verify your transactions.',
    objective_of_trading_title: 'Objective of trading',
    id_card_format:
      'ID Card laser code must follow the format XX0000000000 or XX0-0000000-00',
    telephone_invalid: 'Telephone number must contain digits only',
    telephone_min: 'Telephone number must be at least 9 digits',
    telephone_max: 'Telephone number must not exceed 20 digits'
  },
  profile: {
    profile: 'Profile',
    display_name: 'Display Name',
    email_address: 'Email Address',
    connect_with_facebook: 'Connect with Facebook',
    connect_facebook_acc: 'Connect system with facebook account',
    connect_with_google: 'Connect with Google',
    connect_google_acc: 'Connect system with google account',
    indentification: 'Indentification', //new
    indentification_detail:
      'User must fill the identity verification form and upload supplementary documents', // new
    exchange_condition: 'Start trading once you completed the verification',
    suit_test: 'Suitability Test', //new
    suit_test_detail:
      'Questionnaire to assess the suitability of customer investment', //new
    knowledge_test: 'Knowledge Test', // new
    knowledge_test_detail:
      'Questionnaire to assess knowledge about customer investment', //new
    take_a_test: 'Take a test',
    verification: 'Verification', // new
    two_fact: 'Two-Factor Authentication',
    two_fact_detail:
      'Stronger security for your account with 2-step verification',
    identity_requirement:
      'User must fill the identity verification form and upload supplementary documents',
    status_verification: 'Verification',
    status_pending: 'Pending',
    status_verified: 'Verified',
    status_rejected: 'Rejected',
    status_incorrect_information: 'Incorrect information',
    status_passed: 'Pass',
    upload_profile_picture: 'Upload profile picture',
    display_name_max: 'Display name must be no longer than {{count}} characters'
  },
  login: {
    remember_me: 'Remember me',
    login_uppercase: 'LOGIN',
    register_now: 'Register Now'
  },
  register: {
    register: 'Register',
    register_uppercase: 'REGISTER',
    login_with: 'Login with {{provider}}',
    or: 'OR',
    email: 'Email',
    password: 'Password',
    terms_of_use: 'I agree with Terms of Use, Privacy Policy and AML/KYC' //new
  },
  forgot_password: {
    forgot_password: 'Forgot Password?',
    forgot_password_detail: `Enter your email address and we'll send you an email with instructions to reset your password.`
  },
  kyc: {
    kyc: 'KYC',
    kyc_placeholder: 'Enter your ID card code.',
    kyc_regist_com: 'KYC registration completed'
  },
  menu: {
    profile: 'Profile',
    tradeHistory: 'Transaction History',
    kyc: 'Identification',
    suit_test: 'Suitability Test',
    knowledge_test: 'Knowledge Test',
    knowledge_test_correct_answer: 'Correct Answer',
    logout: 'Logout'
  },
  suit_test: {
    country: 'country no.{index}',
    q_1: {
      q: 'What is your age?',
      a_1: '20 years old or below.',
      a_2: 'From 20 years old but not over 30 years old.',
      a_3: 'From 30 years old but not over 45 years old.',
      a_4: 'From 45 years old but not over 60 years old.',
      a_5: '60 years old or above.'
    },
    q_2: {
      q: 'Level of education',
      a_1: `Under bachelor’s degree.`,
      a_2: `Bachelor's degree.`,
      a_3: 'Master’s degree or above.'
    },
    q_3: {
      q: 'Purpose of using services (Can choose more than 1 item)',
      a_1: 'Savings',
      a_2: 'Investment',
      a_3: 'Transferring international digital assets',
      a_4: 'Purchasing ICO Tokens',
      a_5: 'Others'
    },
    q_4: {
      q: 'Investment period (The expected investment period in digital assets)',
      a_1: 'Not over 1 month.',
      a_2: 'More than 1 month but not over 6 months.',
      a_3: 'Over 6 months but not over 1 year.',
      a_4: 'More than 1 year but not over 3 years.',
      a_5: '3 years and above.'
    },
    q_5: {
      q: 'Source of income (Can choose more than 1 item)',
      a_1: `Savings`,
      a_2: 'Salary / wage',
      a_3: 'Inheritance / gift',
      a_4: 'Personal business',
      a_5: 'Instruments / funds',
      a_6: 'Parent',
      a_7: 'Others'
    },
    q_6: {
      q: 'What countries do you have your income from?',
      a_1: `Source of income from a single country`,
      a_2: 'Source of income is 80% or more from Thailand, the rest is from another country',
      a_3: 'Source of income is less than 80% from Thailand, the rest is from another country',
      a_4: 'Source of income is from 2 countries and not from Thailand',
      a_5: 'Source of income is from more than 2 countries and not from Thailand'
    },
    q_7: {
      q: 'Average monthly income',
      a_1: `Less than 10,000 baht (less than 300 USD)`,
      a_2: '10,000 - 14,999 baht (300 USD - 449 USD)',
      a_3: '15,000 - 34,999 baht (450 USD - 999 USD)',
      a_4: '35,000 - 49,999 baht (1,000 USD - 1,499 USD)',
      a_5: '50,000 - 99,999 baht (1,500 USD - 2,999 USD)',
      a_6: '100,000 - 499,999 baht (3,000 USD - 14,999 USD)',
      a_7: 'More than 500,000 baht (more than 15,000 USD)'
    },
    q_8: {
      q: 'Total amount of assets owned',
      a_1: `Less than 500,000 baht (less than 15,000 USD)`,
      a_2: '500,000 - 1,000,000 baht (15,000 USD - 29,999 USD)',
      a_3: '1,000,000 - 5,000,000 baht (30,000 USD - 149,999 USD)',
      a_4: '5,000,000 - 10,000,000 baht (150,000 USD - 299,999 USD)',
      a_5: '10,000,000 - 100,000,000 baht (300,000 USD - 2,999,999 USD)',
      a_6: 'More than 100,000,000 baht (more than 3,000,000 USD)'
    },
    q_9: {
      q: 'Proportion of investment between digital assets and all assets',
      a_1: `Less than 10 percent.`,
      a_2: 'From 10 percent but not over 30 percent.',
      a_3: 'From 30 percent but not over 50 percent.',
      a_4: 'From 50 percent but not over 80 percent.',
      a_5: 'More than 80 percent.'
    },
    q_10: {
      q: 'Do you have any investing experience in securities? (securities mean investment units, shares, debentures, government bonds, derivatives digital assets or other similar financial instruments)',
      a_1: `None`,
      a_2: '1 year',
      a_3: 'From 1 year but not over 3 years.',
      a_4: 'From 3 years but not over 10 years.',
      a_5: 'More than 10 years.'
    },
    q_11: {
      q: 'Acceptable level of investment risk',
      a_1: `Cannot accept any risk, prefer a secure investment, Generate regular income despite low returns.`,
      a_2: 'Can accept moderate risk for receiving the opportunity to gain higher returns in higher long-term returns.',
      a_3: 'Can accept high risk for receiving the opportunity to gain higher returns in higher long-term returns.',
      a_4: 'Can accept any risk at the highest level for receiving the opportunity to gain the highest returns in the investment.'
    },
    q_12: {
      q: 'How much do you think you can accept the loss of your investment?',
      a_1: `Unacceptable for any loss.`,
      a_2: 'Less than 10 percent of the investment.',
      a_3: 'Approximately 10 - 30 percent of the investment.',
      a_4: 'Approximately 30 - 70 percent of the investment.',
      a_5: 'Acceptable for all losses.'
    },
    q_13: {
      q: 'Have you been judged guilty of offenses relating to the property or the court ordered that the property belongs to the state?',
      a_1: `No, I haven’t.`,
      a_2: 'Yes, I have'
    },
    q_14: {
      q: 'Have you been requested to declare the list of your assets to government agencies such as Office of the National Anti-Corruption Commission, Anti-Money Laundering Office?',
      a_1: `No, I haven’t.`,
      a_2: 'Yes, I have'
    },
    q_15: {
      q: 'Are you or any of your immediate family members (such as parents, spouse, or children), or any close associates, currently holding or have previously held a political or government position in any country?',
      a_1: 'No',
      a_2: 'Yes'
    },
    alert_message:
      '*Please read message or scroll through message to the end of the line.',
    accept_acknowledge_risk:
      'The Customer read and understand all the risks associated with the digital assets trading transactions.'
  },
  knowledge_test: {
    cryptocurrency: {
      q_1: {
        q: 'What is a Cryptocurrency?',
        a_1: 'An electronic data unit was created to serve as a intermediary of exchange, services, digital assets or other rights by encrypted on a system called “Blockchain”.',
        a_2: 'A type of stock issued by the government.',
        a_3: 'Gold price-bound funds'
      },
      q_2: {
        q: 'What are the features of Stablecoins?',
        a_1: 'It is a cryptocurrency that pegs its value to stable assets.',
        a_2: 'Volatility increases several times in a short time.',
        a_3: 'There is a harsh decrease in value over time.'
      },
      q_3: {
        q: 'What is the difference between cryptocurrency and gold?',
        a_1: 'Cryptocurrency can be traded and accumulated for speculation.',
        a_2: 'Cryptocurrency is encrypted and store data with Blockchain technology',
        a_3: 'Gold has a trading price that varies according to market conditions.',
        a_4: 'All correct'
      },
      q_4: {
        q: 'What is the difference between cryptocurrency and traditional Assets?',
        a_1: 'Cryptocurrency use Blockchain technology',
        a_2: 'Can trade through intermediaries such as Exchange, Broker or Dealer',
        a_3: 'Can be used as an intermediaries for exchanging under Thai law',
        a_4: 'All correct'
      },
      q_5: {
        q: 'Which of the following is correct about cryptocurrency and digital tokens?',
        a_1: 'Cryptocurrencies and digital tokens be or be not an electronic data units.',
        a_2: 'Cryptocurrencies were created to serve as a medium for trading goods or services. Whereas digital tokens are created to assign holders the right to acquire goods or services or any other rights',
        a_3: 'Securities (eg stocks, bonds, etc.) built on the Blockchain not considered securities. Rather, it could be a cryptocurrency digital asset or a digital token',
        a_4: 'Stablecoins are not considered as a cryptocurrencies or digital tokens.'
      },
      q_6: {
        q: 'Which of the following is incorrect?',
        a_1: 'Cryptocurrencies and digital tokens have the same meaning.',
        a_2: 'A digital token is an electronic data unit created on the system for the purpose of the right to participate in any project or activity. or assigning the right to acquire a specific product or service',
        a_3: 'Cryptocurrency is an electronic data unit created with the intention of being used as a medium for the exchange of goods or services',
        a_4: 'Nothing is correct'
      },
      q_7: {
        q: 'Which of the following is not the meaning of Stablecoin?',
        a_1: 'Cryptocurrency based on the value of another asset, such as gold or oil.',
        a_2: 'Cryptocurrency that are often bought for speculation',
        a_3: 'Cryptocurrency with less volatility than other types of cryptocurrency.',
        a_4: 'Cryptocurrency that retain their value with different currencies'
      },
      q_8: {
        q: 'What are the features of cryptocurrency?',
        a_1: 'An electronic data unit created on an electronic system or network.',
        a_2: 'It is intended to be used as a medium for exchanging',
        a_3: 'There is no guarantee that the debt can be legally used.',
        a_4: 'All correct'
      },
      q_9: {
        q: 'Which of the following is incorrect about Stablecoin?',
        a_1: 'It is classified as one of the types of the cryptocurrencies under Thai law.',
        a_2: 'There is a mechanism to maintain value against other assets',
        a_3: 'The price will not fluctuate according to demand of the markets',
        a_4: 'Bitcoin and Ethereum are stable coins'
      },
      q_10: {
        q: 'Which of the following is incorrect about the difference between Cryptocurrency, Digital tokens and assets',
        a_1: 'Digital asset transactions can be done without going through a central authority. It can be performed and verified by a protocol confirmation across the entirely network',
        a_2: 'Digital assets can trade for 24 hours a day and it is delivered in real time.',
        a_3: 'Most digital asset do not returns the dividends. like the original asset.',
        a_4: 'The price of digital assets that will not change according to market demand like the original asset.'
      },
      q_11: {
        q: 'What are not the features of cryptocurrency?',
        a_1: 'Cryptocurrency is money that every central bank in the world guarantees that it can be legally used to pay debts or financial obligations',
        a_2: 'Cryptocurrency was created by Blockchain technology, supporting exchanges between users.',
        a_3: 'Cryptocurrency can not be used as a medium for exchanging goods and services under Thai law.',
        a_4: 'Cryptocurrency can trade in Exchange, Broker or Dealer.'
      },
      q_12: {
        q: 'Which of the following is meaning of stablecoin?',
        a_1: 'There is a system to protect user identity.',
        a_2: 'Determine the right to join any project',
        a_3: 'The valued is relatively stable. The price moves by asset collateralized',
        a_4: 'Coin that are created for fun, meme or trendy'
      },
      q_13: {
        q: 'Which of the following is correct?',
        a_1: 'Fiat currencies such as the US Dollar can be used to pay debts or financial obligations',
        a_2: 'Digital tokens cannot be trade for limited. ',
        a_3: 'Digital tokens cannot be used for fundraising.',
        a_4: 'Cryptocurrency can be used to pay for goods and services like a fait currency'
      },
      q_14: {
        q: 'Which of the following is incorrect about the features of cryptocurrency?',
        a_1: 'An electronic unit created on an electronic network to serve as a medium for the exchange of goods or services.',
        a_2: 'An electronic unit created on an electronic network to determine rights.',
        a_3: 'An electronic units created on electronic networks to express ownership rights in goods or services.',
        a_4: 'An electronic unit created on an electronic network for identity verification.'
      },
      q_15: {
        q: 'Which of the following is meaning of cryptocurrency?',
        a_1: 'Cryptocurrency is classified as a highly volatile asset compared to other types of investments',
        a_2: '“Bitcoin” is a cryptocurrency',
        a_3: 'Cryptocurrency is a part of Blockchain technology',
        a_4: 'Currently, cryptocurrency can be used to settle the legal debts'
      },
      q_16: {
        q: 'What is the legal status of cryptocurrency in Thailand?',
        a_1: 'is illegal.',
        a_2: 'is a digital assets.',
        a_3: 'is a type of currency.',
        a_4: 'is an electronic data.'
      },
      q_17: {
        q: 'Which statement below is not correct?',
        a_1: 'Cryptocurrency has the definition same as token',
        a_2: 'Tokens are digital units created with a purpose defined by the issuer and will differ in function and utility',
        a_3: 'Cryptocurrency is a type of digital assets that uses cryptography for security and has been designed as a means of payment similar to a currency',
        a_4: 'None of the above'
      },
      q_18: {
        q: 'Which coin is not a stablecoin?',
        a_1: 'USDT',
        a_2: 'DAI',
        a_3: 'ETH',
        a_4: 'TUSD'
      }
    },
    blockchain: {
      q_1: {
        q: 'Which of the following make blockchain safe?',
        a_1: 'Transparency and easy to verify',
        a_2: 'Data is encrypted. ',
        a_3: 'Difficult to edit data',
        a_4: 'All correct'
      },
      q_2: {
        q: 'Which of the following is correct about blockchain?',
        a_1: 'Blockchain is irrelevant with cryptocurrencies.',
        a_2: 'Blockchain is a centralized system',
        a_3: 'Blockchain is a technology that stores cryptocurrency transaction data. '
      },
      q_3: {
        q: 'What is a "Proof-of-Stake Consensus"?',
        a_1: 'A consensus mechanism to validate new transactions by providing a "validator" holding a predetermined amount of digital assets. And once the transaction is reviewed, the reviewer earn a reward.',
        a_2: 'A consensus mechanism where miners solve cryptographic puzzles to validate new transactions and earn a reward',
        a_3: 'A consensus mechanism for random a validators take action manually in order to validate new transactions and earn a reward',
        a_4: 'None of the above'
      },
      q_4: {
        q: 'What is a Proof-of-Work Consensus?',
        a_1: 'A consensus mechanism in which “validators” lock up set amounts of cryptocurrency or digital tokens in order to validate new transactions and earn a reward',
        a_2: 'A consensus mechanism that validates transactions by having a "miner" solve cryptographic puzzle and once the transaction is verified, the reviewer earn a reward.',
        a_3: 'A consensus mechanism for random a validators take action manually in order to validate new transactions and earn a reward',
        a_4: 'None of the above'
      },
      q_5: {
        q: 'What will happen if you send your coins to the wrong address?',
        a_1: 'Your coins will not be sent since it is an incorrect address and will remain in your account',
        a_2: 'Your coins will be sent to the incorrect address and may be impossible to retrieve',
        a_3: 'You coins will still be sent to the correct address regardless',
        a_4: 'None of the above'
      },
      q_6: {
        q: 'What is a Blockchain technology?',
        a_1: 'Blockchain technology use for storing data in each period, linked like a chain and all data will be copied and distributed  to all users of the system',
        a_2: 'Technology that does not require middleman but let all the participater in the Blockchain network can verify each other cause a diffucult or impossible to edit data on Blockchain',
        a_3: 'Technology that can improving a smart contract for processing the condition in the form of If-Then can make a transaction successfully',
        a_4: 'All correct'
      },
      q_7: {
        q: 'which of the following is not a risk of Blockchain technology?',
        a_1: 'The connecting between a basic construction and Blockchain network that does not stable enough can be effected all the data processing on the system',
        a_2: 'The change of data is the cause of no transparency in the system',
        a_3: 'The change of technology is the cause of cyber threats increasing',
        a_4: 'The change of legal supervision'
      },
      q_8: {
        q: 'What is a meaning of Node?',
        a_1: 'Blockchain',
        a_2: 'A type of cryptocurrency',
        a_3: 'Computers connected to the Blockchain network',
        a_4: 'Types of digital asset wallets'
      },
      q_9: {
        q: 'What are not the features of Blockchain?',
        a_1: 'Borderless',
        a_2: 'Customizability',
        a_3: 'Ownership',
        a_4: 'Immutable'
      },
      q_10: {
        q: 'What are the basic of Blockchain technology which is irrelevant to the creation and trading a Cryptocurrency process.',
        a_1: 'Data Integrity',
        a_2: 'Data Transparency',
        a_3: 'Transaction tracsability',
        a_4: 'Ability of identification'
      },
      q_11: {
        q: 'Which of the following is not Blockchain technology?',
        a_1: 'Able to do a Peer-to-Peer transactions',
        a_2: 'Decentralized processing ',
        a_3: 'Transactions recorded on the Blockchain can be edited. ',
        a_4: 'Blockchain databases store in blocks that are linked like a chain.'
      },
      q_12: {
        q: 'Which of the following is Blockchain technology?',
        a_1: 'Decentralized processing technology',
        a_2: 'Recorded data in the Blockchain system is difficult to modify',
        a_3: 'Information is reliable and verifiable',
        a_4: 'All correct'
      },
      q_13: {
        q: 'Which of the following is not a collecting data in Blockchain?',
        a_1: 'Block structure design',
        a_2: 'Collect the data in many locations',
        a_3: 'Centralized data collection'
      },
      q_14: {
        q: 'Blockchain technology is secure due to its invariability from three underlying aspects; decentralization, cryptography, and consensus. Is this statement true or false?',
        a_1: 'True',
        a_2: 'False'
      },
      q_15: {
        q: 'Investors must be vigilant and not fall for A cyber attack. Protecting and keeping one’s private key safe is very important. Anyone that possesses your private key can access your funds. What should you do with your private key?',
        a_1: 'I can leave my private key lying around for everyone to see.',
        a_2: 'I should share my private key with my friends.',
        a_3: 'I should not reveal my private key to anyone.',
        a_4: 'I should make a digital copy of my private key and store it online.'
      },
      q_16: {
        q: 'What are the strengths of Blockchain?',
        a_1: 'Increase the reliability of data storage',
        a_2: 'Information cannot be changed or modified.',
        a_3: "Don't use intermediaries to store and verify information.",
        a_4: 'All correct'
      },
      q_17: {
        q: 'What is Blockchain splits?',
        a_1: 'A split',
        a_2: 'A division',
        a_3: 'A sidechain',
        a_4: 'A fork'
      },
      q_18: {
        q: 'What is Public blockchain?',
        a_1: 'A digital ledger where data is stored on a network of independent computers',
        a_2: 'A digital ledger that is created and managed by a company but is made available to the public',
        a_3: 'A government-facilitated platform for currency exchange',
        a_4: 'A type of computer created for bitcoin mining'
      },
      q_19: {
        q: 'What is/are properties of Blockchain?',
        a_1: 'Decentralized',
        a_2: 'Immutable',
        a_3: 'Consensus',
        a_4: 'All of the above'
      },
      q_20: {
        q: 'Which statement is correct regarding smart contract?',
        a_1: 'NFT technology does not require smart contract',
        a_2: 'A program that stores information in Blockchain and automatically execute based on pre-determined conditions',
        a_3: 'Smart Contract can change transaction history',
        a_4: 'All of the above'
      }
    },
    cryptocurrency_wallet: {
      q_1: {
        q: 'What will happen if you send a Digital asset to the wrong wallet address?',
        a_1: 'The digital asset will be reversed back to your wallet.',
        a_2: 'The digital asset will be lost permanently.'
      },
      q_2: {
        q: 'What might happen when entering the address of the recipient wrong.',
        a_1: "Coins will be returned to the last account because the recipient's address is incorrect.",
        a_2: 'Coins will be transferred to the destination but not the correct account.',
        a_3: 'Nothing happened, the coin was transferred to the destination correctly.',
        a_4: 'A and B are correct.'
      },
      q_3: {
        q: 'What are the risks that may arise from using the service through an exchange platform?',
        a_1: 'The service provider (Cryptocurrency Exchange) will keep the private key.',
        a_2: 'The platform has an error causing it can not trade',
        a_3: 'The cryptocurrencies in the account were lost due to  Exchange was attacked by hacker',
        a_4: 'All correct'
      },
      q_4: {
        q: 'Which of the following is correct about digital asset wallet',
        a_1: 'Store the cryptocurrency before they are used. ',
        a_2: 'Calculate the price of cryptocurrency.',
        a_3: 'It should not be used because of its low security.'
      },
      q_5: {
        q: 'How can you tranfer your cryptocurrency completely?',
        a_1: 'Verify the recipient wallet address every time before tranfer.',
        a_2: 'Study and understand the transfer process or ask the staff for advice',
        a_3: 'All correct'
      },
      q_6: {
        q: 'Where can investors store cryptocurrency and digital tokens?',
        a_1: 'Bank account',
        a_2: 'Hot wallet',
        a_3: 'Cold wallet',
        a_4: 'Correct both B and C '
      },
      q_7: {
        q: 'Which of the following is correct about hot wallet and cold wallet?',
        a_1: "Digital asset operators in Thailand must store most of their customer's cryptocurrency in a cold wallet or store them with digital asset custody.",
        a_2: 'Cold Wallet is more secure from hacker than hot wallet.',
        a_3: "If the digital wallet's private key is accessed or disclosed to publiC. The investor should immediately move cryptocurrency out of digital wallet to be stored elsewhere.",
        a_4: 'Investors should store their private keys with Cloud providers.'
      },
      q_8: {
        q: 'How to keep your digital asset wallet?',
        a_1: 'Store the cryptocurrency for spent in hot wallet and store the remaining cryptocurrency in cold wallet.',
        a_2: 'Must have a reserved wallet if the prior wallet was damaged, lost or stolen.',
        a_3: 'Refrain from connecting to public WiFi.',
        a_4: 'All correct.'
      },
      q_9: {
        q: 'What are the advantages of depositing cryptocurrency in custodial wallet?',
        a_1: "Service providers will have a storage system. So don't worry about that.",
        a_2: 'Customers make transactions easily.',
        a_3: 'All correct.'
      },
      q_10: {
        q: 'Which of the following is correct about types and usability of digital assets?',
        a_1: 'Hardware wallet is a custodial wallet device. The private key is stored on the device offline, making it highly secure from cyber attack',
        a_2: 'Paper wallet is a non-custodial wallet. Users creating wallet on the website and keep private key by writing down on a note or paper but risky from faded ink or lost',
        a_3: 'Desktop/ Mobile wallet is a non-cutodial wallet by installing wallet program into computer or smartphone and store the encrypted private key in it. Security depends on the level of security of the device itself',
        a_4: 'B and C are correct'
      },
      q_11: {
        q: 'Which of the following is correct about depositing Cryptocurrency in custodial wallet?',
        a_1: "There is a segregation of customer assets from the operator's assets.",
        a_2: "Customers can send orders to transfer the cryptocurrenc out of the operator's wallet by themselves.",
        a_3: "Store most of customer's cryptocurrency with a crytocurrency custodian.",
        a_4: 'All correct.'
      },
      q_12: {
        q: 'What are the benefits of a Digital wallet?',
        a_1: 'used to store banknotes.',
        a_2: 'used to store financial instruments.',
        a_3: 'used to store digital assets.',
        a_4: 'used to store gold bars.'
      },
      q_13: {
        q: 'Which of the following is not a Digital wallet which used to store Cryptocurrency?',
        a_1: 'Hot Wallet',
        a_2: 'Cold Wallet / Storage',
        a_3: 'Hardware Wallet',
        a_4: 'Bank account'
      },
      q_14: {
        q: 'How do you recover the pivate key if you lost your Hardware wallet?',
        a_1: 'Notify the SEC.',
        a_2: 'Use the reserved seed.',
        a_3: 'Cannot be recovered.'
      },
      q_15: {
        q: 'How to verify your transactions?',
        a_1: 'Address',
        a_2: 'Transaction ID',
        a_3: 'All correct'
      },
      q_16: {
        q: 'Which of the following is a type of stablecoin?',
        a_1: 'Fiat-Backed stablecoin',
        a_2: 'Crypto-Backed stablecoin',
        a_3: 'Algorithmic stablecoin',
        a_4: 'All currect'
      },
      q_17: {
        q: 'Cryptocurrency transaction status can be checked using transaction ID (TxID.  or wallet address. Is this statement TRUE or FALSE?',
        a_1: 'TRUE',
        a_2: 'FALSE'
      },
      q_18: {
        q: 'You purchase a hardware wallet to store Bitcoin directly from the manufacturer, set it up, and write the 12 recovery words down on a piece of paper. You send one Bitcoin to the wallet address and confirm it has arrived. Later the hardware wallet is destroyed, and you have lost the recovery words. How can the Bitcoin be recovered?',
        a_1: 'The Bitcoin cannot be recovered.',
        a_2: 'The Bitcoin can be recovered by the hardware wallet manufacturer.',
        a_3: 'The Bitcoin can be recovered by the exchange.',
        a_4: 'The Bitcoin can be recovered by the SEC.'
      },
      q_19: {
        q: 'What are the precautions for beginners about Digital wallet?',
        a_1: 'Fake crypto wallet',
        a_2: 'Do not take a picture of the Seed Phrase, stored on your PC, smart phone, etc.',
        a_3: 'Carefully verify the destination of every transfer.',
        a_4: 'All correct.'
      },
      q_20: {
        q: 'What should you not to do if hold on Cryptocurrency?',
        a_1: 'Manually store cryptocurrency in your Hardware Wallet.',
        a_2: 'Approve your friends to keep cryptocurrency. Because friends are more knowledgeable.',
        a_3: 'Keep cryptocurrency with exchange.',
        a_4: 'Manage the risk of storing cryptocurrency in both hardware wallets and exchanges according to investment.'
      },
      q_21: {
        q: 'What is Cold storage?',
        a_1: 'A desktop wallet',
        a_2: 'Document storage outside of digital devices',
        a_3: 'A private key not connected to the Internet',
        a_4: 'All of the above'
      },
      q_22: {
        q: 'What is a custodial wallet?',
        a_1: "Digital wallet service which store customer's cryptocurrency. The custodial wallet provider will keep the private key.",
        a_2: 'Digital wallet that the provider developed a program without keeping the private key.',
        a_3: 'Name of the company that developed the wallet.',
        a_4: 'All currect'
      },
      q_23: {
        q: 'Which statement(s) is not correct regarding Private Key storage and safe-keeping of digital assets?',
        a_1: 'Keep Private Key in the cloud and an additional copy in your computer',
        a_2: 'Keep private key in paper format and store in a safe',
        a_3: 'Use a Hardware Wallet and store in a safe',
        a_4: 'None of the above'
      },
      q_24: {
        q: 'What is the importance of a private key?',
        a_1: 'Perform as a password and can be used to access funds in digital wallet',
        a_2: 'Perform as an email address and can be sent to others',
        a_3: 'If the Private Key is lost, a new one can easily be created',
        a_4: 'All of the above'
      }
    },
    investment: {
      q_1: {
        q: 'Which of the following is correct about cryptocurrency market?',
        a_1: 'The cryptocurrency market is more volatile than the stock market.',
        a_2: 'The cryptocurrency market is less volatile than the stock market.',
        a_3: 'The cryptocurrency market is not volatile.'
      },
      q_2: {
        q: 'Which of the following affected the price of cryptocurrency?',
        a_1: 'News related to the cryptocurrency',
        a_2: 'Situations affecting world market conditions',
        a_3: 'All currect '
      },
      q_3: {
        q: 'Which of the following is not a factor in the fundamental valuation of cryptocurrency?',
        a_1: 'The quantity of coins is limited or can be created more.',
        a_2: 'Smart Contracts used with cryptocurrency should be reviewed by reliable auditors.',
        a_3: 'Utilization or rights of cryptocurrency',
        a_4: 'Price volatility'
      },
      q_4: {
        q: 'Which the investment  is acceptable risk?',
        a_1: 'Can take a 10% loss of total investment : invest 10% in cryptocurrencies',
        a_2: 'Can take a 50% loss of the total investment : invest 50% in cryptocurrencies',
        a_3: 'Can take a 100% Loss of Total Investment : invest 100% in cryptocurrencies',
        a_4: 'All  correct'
      },
      q_5: {
        q: 'What are the characteristics of the cryptocurrency market?',
        a_1: 'It is a highly volatile market.',
        a_2: 'It is  illegal in some countries.',
        a_3: 'It is a market that can be traded 24 hours a day.',
        a_4: 'All correct.'
      },
      q_6: {
        q: 'Which of the following is correct about the cryptocurrency market affecting investments?',
        a_1: 'Market trends will drive all industries to digitize (Digitalization)',
        a_2: 'Although the cryptocurrency market is highly volatile. But there are new investors is increasing steadily over the years',
        a_3: 'Social media is an important tool to analyze the market for novice cryptocurrency investors.',
        a_4: 'All correct'
      },
      q_7: {
        q: 'Which of the following is incorrect about cryptocurrency price volatility?',
        a_1: 'The cryptocurrency market is less volatile than the stock market.',
        a_2: 'News and celebrity influence cryptocurrency price volatility',
        a_3: 'Economic stability affects cryptocurrency price volatility',
        a_4: 'Price volatility affects the credibility of cryptocurrencies. If there is a low level of credibility The risk will be high. And it affects the decision to invest in cryptocurrencies.'
      },
      q_8: {
        q: 'Which of the following is not a risk management?',
        a_1: 'Invest with acceptable risks',
        a_2: 'Always monitoring your cryptocurrency trading account.',
        a_3: 'Study and understamding the informations before making an investment decision.',
        a_4: 'Invest with focus on cryprocurrency investments solely'
      },
      q_9: {
        q: 'Which of the following is incorrect?',
        a_1: 'Be careful and check the validity in every digital asset transfer to prevent loss',
        a_2: 'Cryptocurrencies are relatively stable in value, so investors with low risk tolerance should have their stake in cryptocurrencies more than any other assets',
        a_3: 'Prices and trading volumes of cryptocurrencies depends on factors such as demand and supply at the moment, news from platform developers or from influencers through different social media',
        a_4: 'Investors should research, make a diversified risks and have investment strategies to suit their own risk assessment results.'
      },
      q_10: {
        q: 'Which of the following is most correct about the way to calculate the value of cryptocurrency?',
        a_1: 'Valuate the market value of cryptocurrencies with the value of gold.',
        a_2: 'Valuate in the same way as other currencies based on the volume of money in the system.',
        a_3: 'Valuate the value of cryptocurrencies as goods and products by calculating the cost of production.',
        a_4: 'The most valuation of cryptocurrencies is still new and there is no definite theory to support it.'
      },
      q_11: {
        q: 'Which of the following is correct about cryptocurrency market?',
        a_1: 'Open for trading 24 hours a day',
        a_2: 'The assets traded are in the form of cryptocurrencies and digital tokens.',
        a_3: 'The risks and price volatility of each cryptocurrency/digital token may vary on economics.',
        a_4: 'All correct'
      },
      q_12: {
        q: 'Which statement is not the action(s) to take when investing in cryptocurrency?',
        a_1: 'Invest according to advice from experts',
        a_2: 'Research extensively about the coin before investing',
        a_3: 'Research the white paper of the coin before investing',
        a_4: 'Evaluate your risk tolerance before investing'
      },
      q_13: {
        q: 'Which of the following is correct about the risk investment in cryptocurrency?',
        a_1: 'Low risk and low yields.',
        a_2: 'The trading price is highly volatile. You can lose all your investments in short time.',
        a_3: 'Moderate risk and high yields.',
        a_4: 'Each cryptocurrency has different risks.'
      },
      q_14: {
        q: 'Which of the following is incorrect about estimate the risk if coins or tokens were price abnormally high before trading?',
        a_1: 'Compare the price with other providers before trading',
        a_2: 'Contact the provider to check whether the coin is abnormal or not.',
        a_3: 'Find an opportunity to make a profit immediately.',
        a_4: 'Cancel the order immediately for prevent unwanted  order.'
      },
      q_15: {
        q: 'How much is the asset risk level of cryptocurrency?',
        a_1: 'High risk',
        a_2: 'Medium risk',
        a_3: 'Low risk',
        a_4: 'There is no risk.'
      },
      q_16: {
        q: 'Which of the following is correct about preparing to trade the cryptocurrencies?',
        a_1: 'Invest with acceptable risk.',
        a_2: 'Choose a platform that certified by the government agency.',
        a_3: 'Study the information of each cryptocurrency before trading',
        a_4: 'All correct.'
      },
      q_17: {
        q: 'What are the kind of trading that inexperienced investors should avoid?',
        a_1: 'Margin trading',
        a_2: 'Spot trading',
        a_3: 'Holding',
        a_4: 'All correct'
      },
      q_18: {
        q: 'Which of the following should not be done to invest in cryptocurrency',
        a_1: 'Always research the cryptocurrency information.',
        a_2: 'Diversify risks appropriately and invest with acceptable risk.',
        a_3: 'All-In in a coin',
        a_4: 'All of the above are correct.'
      },
      q_19: {
        q: 'What are the factors may cause of digital asset price down?',
        a_1: 'The popularity and demand for digital assets will increase in the future',
        a_2: 'High Net Worth and Large Fund buy digital assets because they want to diversify their investment portfolios (Asset Aallocation)',
        a_3: 'FED begin a program of quantitative tightening by reducing liquidity from the financial system it will impact on financial markets including digital assets',
        a_4: 'Non of the above are correct'
      },
      q_20: {
        q: 'Which statement is not the action(s) to take when investing in cryptocurrency?',
        a_1: 'Invest according to advice from experts',
        a_2: 'Research extensively about the coin before investing',
        a_3: 'Research the white paper of the coin before investing',
        a_4: 'Evaluate your risk tolerance before investing'
      },
      q_21: {
        q: 'How is the market capitalization of cryptocurrency calculated?',
        a_1: 'Market price * Volume of deposit and withdrawal',
        a_2: 'Market price * Volume of assets',
        a_3: 'Market price * Trading demand',
        a_4: 'All currect'
      }
    }
  },
  summary_of_suit_test: {
    title: 'Suitability Test Results',
    user_risk_point:
      'Total scores are between <b>{{suitabilityTestPoint}}</b> to <b>50</b>',
    user_risk_level: {
      low: `<b>Low-risk Investor.</b> This type of investor has a small tolerance for investment risk. You require a certainly low return more than uncertain investment.<br><br>
      <b>Investment risk tolerance and a suitable type of financial instrument are bank deposits or government bond.</b><br><br>
        <i>“The digital assets market price is fluctuations in a short time. Investors should study and understand the basics of digital asset investments before investing and always follow digital asset news during the investment period.”</i>`,
      medium: `<b>Medium-to-moderate-low-risk Investor.</b> This type of investor has rather small investment risk tolerance. You emphasized on capital protection and aim for regular income generated from investment<br><br>
      <b>Investment risk tolerance and a suitable type of financial instrument are government bond, corporate bond or funds.</b><br><br>
        <i>“The digital assets market price is fluctuations in a short time. Investors should study and understand the basics of digital asset investments before investing and always follow digital asset news during the investment period.”</i>`,
      hight: `<b>High-risk Investor.</b> This type of investor is able to accept high investment risk, high market volatility and can accept investment loss with an aim for investment value to grow over the long term.<br><br>
      <b>Investment risk tolerance and a suitable type of financial instrument are a corporate bond or equity funds.</b>`,
      very_hight: `<b>A-very-high-risk Investor.</b> This type of investor is keen for opportunities to generate a high return and is able to accept substantial risk and can accept quite high investment loss.<br><br>
      <b>Investment risk tolerance and a suitable type of financial instrument are a digital assets.</b>`
    },
    backward_btn: 'Go to Exchange',
    invite_knowledge_test: {
      title: 'Would you like to continue a knowledge test?',
      describe:
        'You will be able to trade when your information is verified, completed a suitability test and completed a knowledge test.',
      text_btn: 'Go to Knowledge Test'
    },
    rules_detail: `Decentralized digital asset investment is the digital asset exchange which customers are the person who store assets themselves, therefore, clients should be
      advised to study and understand how to maintain digital assets on their own before every investment. In addition, the transfer of digital assets between the wallet is the
      actual transfer, accordingly, requires time in order to confirm the transaction which might affect the exchange rate, consequently, clients are advised to study the price
      slippage setting and confirmation period for each type of digital asset before making investment decisions.`
  },
  summary_of_knowledge_test: {
    title: 'Knowledge Test Results',
    user_risk_point:
      'Your knowledge scores from <b>{{knowledgeTestPoint}}</b> of <b>10</b>.',
    describe:
      'You can learn more from the following investment advice document.',
    article_1: 'Blockchain 101',
    article_2: 'Bitcoin 101',
    article_3: 'Etheremm 101',
    article_4: 'The Future of Blockchain',
    article_5: 'What is a Wallet? (Cryptocurrency Basics)',
    article_6: 'Investing 101 (Cryptocurrency Basics)',
    invite_suite_test: {
      title: 'Would you like to continue a suitablitity test?',
      describe:
        'You will be able to trade when your information is verified, completed a suitability test and completed a knowledge test.',
      text_btn: 'Go to Suitability Test'
    }
  },
  fees: {
    title: 'Fee Structure',
    description:
      'The total platform fee for purchasing digital assets on KULAP+ is calculated from the sum of the Payment Gateway Fee and the KULAP+ Platform Fee.',
    formula_title: 'Fee Calculation Formula',
    gateway_fee_label:
      'Payment Gateway Fee: Fixed 15 THB per transaction (PromptPay service fee)',
    kulap_fee_label:
      'KULAP+ Platform Fee: 0.2% of purchase amount (KULAP+ platform service fee)',
    total_fee_label: 'Total Fee = 15 THB + (Purchase Amount × 0.2%)',
    table_title: 'Fee Examples',
    table_header_purchase_amount: 'Purchase Amount (THB)',
    table_header_gateway_fee: 'Gateway Fee (THB)',
    table_header_kulap_fee: 'KULAP+ 0.2% (THB)',
    table_header_total_fee: 'Total Fee (THB)',
    note_gas_fee:
      'Fees shown above do not include Network Fee (Gas Fee) from the Blockchain network, which will be displayed separately at order confirmation.',
    note_fee_change:
      'Fee rates may be subject to change. The company will notify users in advance before any changes take effect.',
    note_payment_channel: 'Payment channel: PromptPay'
  },
  footer: {
    products: 'Products',
    support: 'Support',
    social_media: 'Social Media',
    buy_crypto: 'Buy Crypto',
    sell_crypto: 'Sell Crypto',
    fees: 'Fees',
    terms: 'Terms of Services',
    sourced_exchange: 'List of Sourced Exchange',
    quality_of_service: 'Quality of Service Information',
    annual_financial_statements: 'Annual Financial Statements',
    contact_us: 'Contact Us'
  },
  language: {
    title: 'Language',
    select: 'Select language',
    english: 'English',
    thai: 'ไทย'
  },
  navigation: {
    buy: 'Buy',
    sell: 'Sell',
    contact_us: 'Contact Us'
  },
  contact_us: {
    title: 'Contact Us',
    description: 'Get in touch with the team.',
    details_heading: 'Contact details',
    address_label: 'Address',
    address_value:
      '139 Sethiwan Tower, Pan Road, Silom, Bang Rak, Bangkok 10500',
    general_business_label: 'General & Business Partner',
    complaint_label: 'Complaint Channel',
    it_security_label: 'IT Security',
    telephone_label: 'Telephone',
    location_heading: 'Office location',
    map_title: 'Sethiwan Tower office location',
    open_in_google_maps: 'Open in Google Maps',
    map_unavailable_hint:
      'If the map is unavailable, use the link to open the location in Google Maps.'
  },
  auth: {
    login_register: 'Login / Register'
  },
  acknowledge_risk: {
    template: acknowledgeTemplateEn
  },
  terms_and_conditions: {
    template: termsAndConditionsTemplateEn
  },
  transactionHistory: {
    page_title: 'Transaction History',
    columns: {
      date_time: 'Date Time',
      pair: 'Pair',
      side: 'Side',
      from: 'From',
      receive: 'Receive',
      network: 'Network',
      tx_hash: 'Transaction Hash',
      wallet_address: 'Wallet Address',
      status: 'Status',
      action: 'Detail'
    },
    filters: {
      date_range: 'Date Range',
      side: 'Side',
      network: 'Network',
      token: 'Token',
      status: 'Status',
      all: 'All',
      download: 'Download CSV',
      pick_start: 'Select start date',
      pick_end: 'Select end date',
      export: 'Export Transaction'
    },
    pagination: {
      rows_per_page: 'Rows per page',
      previous: 'Previous',
      next: 'Next'
    },
    side_values: {
      buy: 'Buy',
      sell: 'Sell'
    },
    status_values: {
      success: 'Success',
      failed: 'Failed',
      pending: 'Pending',
      cancelled: 'Cancelled',
      expired: 'Expired',
      processing: 'Processing',
      refund_pending: 'Refund Pending',
      refund_success: 'Refund Success',
      pending_verification: 'Pending Verification',
      refund: 'Refund'
    },
    detail_modal: {
      title: 'Transaction Detail',
      title_buy: 'Buy Details',
      title_sell: 'Sell Details',
      core_info: 'Core Information',
      order_id: 'Order ID',
      order_display_id: 'Order No',
      side: 'Side',
      status: 'Status',
      created_at: 'Date Time',
      network: 'Network',
      network_info: 'Network',
      from: 'From',
      receive: 'Receive',
      fee: 'Fee',
      payment_info: 'Payment Information',
      fiat_amount: 'Fiat Amount',
      payment_status: 'Payment Status',
      payment_method: 'Payment Method',
      payment_at: 'Payment At',
      trade_info: 'Trade Information',
      from_crypto: 'From Crypto',
      to_crypto: 'To Crypto',
      tx_hash: 'Transaction Hash',
      wallet_address: 'Wallet Address',
      dex_route: 'DEX Route',
      fee_breakdown: 'Fee Breakdown',
      platform_fee_thb: 'Platform Fee (THB)',
      platform_fee_usd: 'Platform Fee (USD)',
      network_fee_thb: 'Network Fee (THB)',
      network_fee_usd: 'Network Fee (USD)',
      disbursement_info: 'Disbursement Information',
      disbursement_status: 'Disbursement Status',
      gross_amount: 'Gross Amount',
      net_amount: 'Net Amount',
      provider: 'Provider',
      refund_status: 'Refund Status',
      copy_success: 'Copied!',
      close: 'Close'
    },
    empty_state: {
      no_transactions: 'No transactions found'
    },
    errors: {
      date_required_both: 'Please provide both start date and end date',
      date_range_too_long: 'Date range must not exceed 365 days',
      download_failed: 'Failed to download transaction history'
    }
  },
  ui: {
    sent: 'Sent',
    new_password: 'New Password',
    confirm_payment: 'Confirm payment',
    you_get: 'You get',
    recipient_address: 'Recipient address',
    chain: 'Chain',
    please_fill: 'Please fill',
    objective_of_trading: 'Please fill objective of trading',
    select_province: 'Select Province',
    select_district: 'Select District',
    select_sub_district: 'Select Sub District',
    zipcode: 'Zipcode',
    type_number: 'Type a number from zero to one',
    country: 'Country',
    select_current_country: 'Select Current Country',
    address: 'Address',
    enter_current_address: 'Enter Current address',
    province: 'Province',
    enter_current_province: 'Enter Current Province',
    district: 'District',
    enter_current_district: 'Enter Current District',
    enter_current_sub_district: 'Enter Current Sub District',
    enter_current_zipcode: 'Enter Current Zipcode',
    id_card_laser_code: 'ID Card laser code',
    enter_id_card_laser_code: 'Enter ID Card laser code. eg. JC0-0000000-00',
    phone_number: 'Phone Number',
    enter_phone_number: 'Enter Phone number',
    occupation: 'Occupation',
    select_occupation: 'Select Occupation',
    enter_other_occupation: 'Enter Other Occupation',
    educational_institution_name: 'Educational Institution Name',
    enter_educational_institution_name: 'Enter Educational Institution Name',
    company_name: 'Company name',
    enter_company_name: 'Enter Company name',
    select_company_country: 'Select Country of the company',
    enter_company_address: 'Enter Company address',
    enter_company_province: 'Enter Province of the company',
    enter_company_district: 'Enter District of the company',
    enter_company_sub_district: 'Enter Sub District of the company',
    enter_company_zipcode: 'Enter Zipcode of the company',
    search_network: 'Search network',
    search_network_ellipsis: 'Search network...',
    no_network_found: 'No network found.',
    transaction: 'Transaction',
    clear_all: 'Clear all',
    pagination: 'Pagination',
    previous: 'Previous',
    next: 'Next',
    more_pages: 'More pages',
    fees: 'Fees',
    slippage: 'Slippage',
    qr_code: 'QR Code',
    order_id: 'Order ID',
    order_date: 'Order date',
    refund_amount: 'Refund amount',
    refund_reason: 'Refund reason',
    refund_status: 'Refund status',
    amount_to_pay: 'Amount to Pay',
    bank_account_name: 'Bank Account Name',
    promptpay_bank_account_notice:
      'For this transaction, ensure you use only your own bank account name.',
    process: 'Process',
    view_transaction: 'View transaction',
    sell_detail: 'Sell Detail',
    loading_sell_details: 'Loading sell details...',
    network: 'Network',
    notice: 'Notice:',
    promptpay_warning:
      'Warning: When transferring via PromptPay, if the ID Card is not connected or does not match the',
    refund_process: 'the transfer will proceed to the refund process',
    bank: 'Bank',
    refund: 'refund',
    bank_account: 'Bank Account Name',
    promptpay_id: 'PromptPay ID',
    payment_channel: 'Payment channel',
    time: 'Time',
    amount: 'Amount',
    search_token: 'Search by token or address',
    connect_wallet: 'Connect Wallet',
    disconnect_wallet: 'Disconnect wallet',
    enter_2fa_code: 'Enter 2FA Code',
    type_text: 'Type a text',
    pick_date: 'Pick a date',
    confirming: 'Confirming',
    select_csv: 'Select a CSV file to upload',
    upload_file: 'Click or drag file to this area to upload',
    uploaded_content: 'Uploaded content',
    payment_method: 'Payment method:',
    amount_title: 'Amount',
    identify_verification: 'Identify Verification',
    information: 'Information',
    kyc_provider: 'KYC Provider',
    incorrect_information: 'Incorrect information',
    kyc_pending_icon: 'KYC pending icon',
    reset_password: 'Reset Password',
    display_name: 'Display Name',
    email_address: 'Email Address',
    identification: 'Identification',
    suitability_test: 'Suitability Test',
    knowledge_test: 'Knowledge Test',
    document_title: 'KULAP Plus - Buy digital assets easily',
    enable_javascript: 'You need to enable JavaScript to run this app.',
    select_network: 'Select Network',
    creating_order: 'Creating Order...',
    confirm_sell: 'Confirm Sell',
    verification_complete: 'Verification complete',
    verification_reviewed: 'We have successfully reviewed your information.',
    pending: 'Pending',
    information_submitted: 'Information has been submitted successfully',
    rejected: 'Rejected',
    identification_rejected: 'Your identification is rejected.',
    contact_support: 'If you need more information please contact',
    retry: 'Retry',
    you_spend: 'You spend',
    you_get_for:
      'You get ~ {{amount}} {{output}} for {{inputAmount}} {{input}}',
    for: 'for',
    status_success: 'Success',
    status_canceled: 'Canceled',
    status_pending: 'Pending',
    fees_included: 'Fees included',
    platform_fee: 'Platform fee',
    network_fee: 'Network fee',
    total_fees: 'Total fees',
    slippage_description:
      'Slippage is the difference between the expected value of output from a trade and the actual value due to asset volatility and liquidity depth. On our platform, if the price received is less than {{percentage}}%, the system will cancel the order.',
    consent_prefix: 'I agree with',
    consent_and: 'and',
    terms_of_services: 'Terms of Services',
    privacy_policy: 'Privacy Policy',
    aml_kyc: 'AML/KYC',
    save_qr_code: 'Save QR Code',
    remaining_time_for_payment: 'Remaining time for payment',
    payment_success: 'Payment Success',
    payment_canceled: 'Payment Canceled',
    payment_refund: 'Payment refund',
    refund_business_days:
      'Please allow 7 business days for refund to be processed',
    please_contact: 'Please contact',
    scan_qr_instruction: 'Please scan the QR code through the application.',
    buy_now: 'Buy now',
    sell_now: 'Sell now',
    switching_network: 'Switching Network...',
    switch_network_to: 'Switch Network to {{chain}}',
    switch_network_and_buy: 'Switch Network & Buy',
    switch_network_and_sell: 'Switch Network & Sell',
    select_token: 'Select token',
    wallet_address: 'Wallet address',
    summary: 'Summary',
    wallet_address_required: 'Wallet address is required',
    wallet_address_placeholder: 'Enter your {{token}} recipient address',
    wallet_address_helper:
      'You can manually enter a custom wallet address or use your connected wallet address',
    accept_all_cookies: 'Accept All Cookie',
    reject_cookies: 'Reject',
    cookie_notice:
      'We use cookies for better performance and user experience of website usage. View our "Privacy Policy" for more information',
    current_address: 'Current Address',
    working_address: 'Working Address',
    current_address_same: 'It is the same as address on Thai ID',
    current_address_different: 'It is different from address on Thai ID',
    copy_address: 'Copy address',
    thailand: 'Thailand',
    sub_district: 'Sub District',
    occupation_other: 'Occupation Other',
    address_guidance_title: 'Guidance on Address Information',
    address_guidance_description:
      'If your occupation is Retired, Freelance, Unemployed, Student or Other, please provide your permanent address.',
    kyc_provider_description:
      'Digital Identity Verification and Authentication System with the ThaiD Application for Thai People',
    kyc_provider_more_info: 'For more information, visit',
    thaid_application: 'Application ThaiD',
    upload_id_card_title: 'Upload photo of your ID Card',
    upload_id_card_instruction:
      'Click or drag file to this area to upload ID Card',
    upload_id_card_required: 'Identification card picture is required',
    upload_selfie_title:
      'Please take a selfie, it’s clearly visible and does not cover your face.',
    upload_selfie_instruction:
      'Click or drag file to this area to upload selfie photo',
    upload_selfie_required: 'Selfie picture is required',
    token_not_exchangeable: 'The token cannot be exchanged',
    identity_conditions:
      'You must confirm your identity under the following conditions',
    confirm_email: 'Confirm Email',
    confirm_email_description:
      'Please confirm your email after completed registration',
    identity_requirement:
      'User must fill the identity verification form and upload supplementary documents',
    detail: 'Detail',
    kyc_request_change_description:
      'Some information is incorrect or needs to be changed. If you need help, please contact support@kulap.io.',
    notification_count_one: 'You have {{count}} new notification.',
    notification_count_other: 'You have {{count}} new notifications.'
  },
  notification: {
    create_order: 'Create order',
    order_success: 'Order success',
    order_failed: 'Order failed',
    payment_pending: 'Payment pending',
    payment_success: 'Payment success',
    payment_failed: 'Payment failed',
    payment_cancelled: 'Payment cancelled',
    payment_refund_pending: 'Payment refund pending',
    payment_refund_success: 'Payment refund success',
    payment_refund_cancelled: 'Payment refund cancelled',
    buy_crypto_pending: 'Buy crypto pending',
    buy_crypto_success: 'Buy crypto success',
    buy_crypto_failed: 'Buy crypto failed',
    sell_crypto_failed: 'Sell crypto failed',
    sell_crypto_deposit_sell: 'Sell crypto - Deposit & sell',
    sell_crypto_thb_processing: 'Sell crypto - THB transfer processing',
    sell_crypto_thb_success: 'Sell crypto - THB transfer success',
    sell_crypto_thb_pending_review: 'Sell crypto - THB transfer pending review',
    sell_crypto_transfer_thb: 'Sell crypto - Transfer THB',
    sell_crypto_completed: 'Sell crypto completed',
    kyc_id_card_duplicate: 'KYC ID card duplicate',
    for_amount: 'for'
  },
  toast: {
    success: 'Success',
    error: 'Error'
  }
}
